export const userLevels = [
    "Internship",
    "Junior L1",
    "Junior L2",
    "Junior L3",
    "Mid L1",
    "Mid L2",
    "Mid L3",
    "Senior L1",
    "Senior L2",
    "Senior L3",
    "Principal",
    "Architect",
] as const;
